import { TabbedForm, FormTab } from 'react-admin'

import PlaylistInfoTab from './PlaylistInfoTab'
import PlaylistBooksTab from './PlaylistBooksTab'
import PlaylistCoursesTab from './PlaylistCoursesTab'

const PlaylistForm = props => {
  return (
    <TabbedForm {...props} redirect="list">
      <FormTab label="Info" redirect="list" variant="standard" margin="normal">
        <PlaylistInfoTab />
      </FormTab>

      <FormTab label="List Books" variant="filled" margin="normal">
        <PlaylistBooksTab />
      </FormTab>

      <FormTab label="List Courses" variant="filled" margin="normal">
        <PlaylistCoursesTab />
      </FormTab>
    </TabbedForm>
  )
}

export default PlaylistForm
